import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  WithStyles,
  withStyles,
  TableHead,
  TextField,
  MenuItem,
  Grid,
  Typography,
  Link,
  Button,
} from "@material-ui/core";
import {
  MyPATTextArea,
  MyPATTextField,
  MyPATDialog,
  MyPATMultiSearch,
} from "../../common";
import MyPATCalendar from "../../common/MyPATCalendar";
import { onlyAllowNumbers } from "../../../utils";
import InputViaDialog from "../common/InputViaDialog";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { userStyles } from "../styles";
import contentRequestServices from "../services/contentRequestServices";
import { ContentRequest, Question, Roles } from "../types/ContentRequest";
import { RequestContentType } from "../types/ContentRequestCreate";
import { Author, AuthorFromAPI, TypeOfAuthor } from "../types/ContentRequest";
import ACLService from "../../acl/services/aclService";
import { getMinimumDateForRoles } from "../helpers/createContentRequest";

import {checkUserRoleMap, checkValidClientUser} from "../helpers/createContentRequest";
import { bindActionCreators } from "redux";
import { setUserByRole } from "../actions/contentRequestActions";

interface Props extends WithStyles<typeof ContentOwnersStyle> {
  transferToParent: (data: any) => void;
  contentsubType: ContentSubType[];
  requestData: ContentRequest;
  requestContentType: RequestContentType;
  onClose: Function;
  userRoleMap: any;
  setUserByRole:Function;
}

interface State {
  testOwnerData: any;
  showContentAuthorsPopup: boolean;
  evaluator: any;
  creator: any;
  languageEvaluator: any;
  moderator: any;
  publisher: any;
  usersList: any;
  authors: any;
  newRequestData: ContentRequest;
  error:any;
  prevAuthors:any
}

class SelectTestOwners extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      testOwnerData: {},
      showContentAuthorsPopup: false,
      evaluator: {endDate: "" },
      creator: {endDate: "" },
      languageEvaluator: {endDate: "" },
      moderator: {endDate: "" },
      publisher: {endDate: "" },
      authors: {},
      usersList: [],
      newRequestData:this.props.requestData,
      prevAuthors:{},
      error:{
        creator: {showError:false,errorText:''},
        evaluator: {showError:false,errorText:''},
        languageEvaluator:  {showError:false,errorText:''},
        moderator:  {showError:false,errorText:''},
        publisher:  {showError:false,errorText:''},
      }
    };
    this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
  }
  componentDidMount() {
    const { requestData } = this.props;
    const authors = _.get(
      requestData,
      "requestInfo.details.testDetails.authors",
      []
    );
    const authorDataByRole = authors.reduce((acc: any, author: any) => {
      if(!author.name.includes(author.client.name)) {
      author.name = `${author.name} | ${author.client.name}`
      }
      acc[author.type] = author;

      return acc;
    }, {});
    const testOwner ={... this.state.newRequestData.requestInfo.owners.find(
      ({ type }) => {
        return type === "test-compiler";
      }
    )};
    let authorDeadlinesByRoles: Roles = defaultEndDates;
    if (testOwner) {
      authorDeadlinesByRoles ={... _.get(testOwner, "roles",authorDeadlinesByRoles)}
    } 
    const creatorEndDate = _.get(authorDeadlinesByRoles, "creator.endDate", "");
    const evaluatorEndDate = _.get(
      authorDeadlinesByRoles,
      "evaluator.endDate",
      ""
    );

    const langEvaluatorEndDate = _.get(
      authorDeadlinesByRoles,
      "languageEvaluator.endDate",
      ""
    );
    const moderatorEndDate = _.get(
      authorDeadlinesByRoles,
      "moderator.endDate",
      ""
    );
    const publisherEndDate = _.get(
      authorDeadlinesByRoles,
      "publisher.endDate",
      ""
    );
    this.setState({ authors: authorDataByRole,
      evaluator: {endDate: evaluatorEndDate },
      creator: {endDate: creatorEndDate },
      languageEvaluator: {endDate: langEvaluatorEndDate },
      moderator: {endDate: moderatorEndDate },
      publisher: {endDate: publisherEndDate },prevAuthors:authorDataByRole });
  }

  handleShowContentAuthorsPopup = () => {
    this.setState({
      showContentAuthorsPopup: true,
    });
  };

  componentDidUpdate(_prevProps: Props, prevState: State) {
    if (prevState.newRequestData !== this.state.newRequestData) {
              
    }
  }

  getUsersByRole = (searchQuery: string, name: string) => {
    let filterItems: any[] = [];
    return contentRequestServices
      .userSuggestionByRole(name, searchQuery)
      .then((res) => {
        res.users.forEach((user: any) => {
          filterItems.push({
            name: `${user.firstName} ${user.lastName} | ${user.clientDetails.name}`,
            id: user._id,
            client:{name:user.clientDetails.name,id:user.clientDetails._id}
          });
        });
        this.setState({ usersList: filterItems });
      });
  };
  handleSuggestionSelect = (
    author: { name: string; id: string },
    authorType: TypeOfAuthor
  ) => {
    const isValid= checkValidClientUser( this.state.authors, author, authorType);
    if(isValid) {
    this.setState((prevState) => {
      const newAuthors = { ...prevState.authors };
      newAuthors[authorType] = {
        ...author,
        type: authorType,
        assignedDate: new Date().toISOString(),
      };
      const error={ ...this.state.error};
      error[authorType]={showError:false,errorText:''}
      this.setState({error})
      return {
        ...prevState,
        authors: newAuthors,
      };
    });
   } else {
    const error={ ...this.state.error};
    error[authorType]={showError:true,errorText:`Authors from different clients cannot be mapped in a subject`}
    this.setState({error})
  }
  };
  handleDeadlineChange = (fieldName: string, value: any) => {
  //  @ts-ignore
    this.setState({[fieldName]:{endDate: new Date(value)}});
  };
  validateAuthors=(authors:any)=>{
    const{userRoleMap}=this.props;  
    const{prevAuthors}=this.state;
    const error={ ...this.state.error};
    const types = [
     "creator",
     "evaluator",
     "languageEvaluator",
     "moderator",
     "publisher",
   ];
   let newUserRoleMap={...userRoleMap}
   // first check in current Popup is anyone having more than 1 role
   const authorsTypeMap:any={};
   let moveForward=true;
   for(let i=0; i<types.length; i++){
     const authorId=_.get(authors,`${types[i]}.id`,"");
    if(_.isEmpty(authorId)){
      continue;
    } 
     if(authorsTypeMap.hasOwnProperty(authorId)){
       error[types[i]]={showError:true,errorText:`The selected ${authors[types[i]].type} is already defined as ${authorsTypeMap[authorId].type} in this request`}
       moveForward=false;
     }else{
       authorsTypeMap[authorId]=authors[types[i]];
       error[types[i]]={showError:false,errorText:''}
     }
   }
   if(!moveForward){
     this.setState({error});
     return false;
   }
   moveForward=true;
 //  In whole Request 
   for(let i=0; i<types.length; i++){
     const authorId=_.get(authors,`${types[i]}.id`,"");
     const prevAuthorId=_.get(prevAuthors,`${types[i]}.id`,"");
     const response=checkUserRoleMap({...newUserRoleMap},authorId,types[i],prevAuthorId);
     if(response.status==='error'){
       error[types[i]]={showError:true,errorText:response.msg};
       moveForward=false;
     }else{
       newUserRoleMap=response.userRoleMap;
     }
    }
    if(!moveForward){
     return this.setState({error},()=>{return false;});
    } 
    this.props.setUserByRole(newUserRoleMap);
    // this.props.onDone(authors); 
   return true; 
  }
  onDone = () => {
    const { newRequestData,creator,evaluator,moderator,languageEvaluator,publisher} = {...this.state};
    
    if(!this.validateAuthors({...this.state.authors}))
       return;

    let user = ACLService.getUserDetailsFromStorage();
    user = user && user.authenticatedUser;
    const loggedInClient={ name: user.clientId.name, id: user.clientId._id };
    const { requestData, transferToParent } = this.props;
    const keys = Object.keys(this.state.authors);
    const authors: any = [];
    keys.forEach((type: any, index: any) => {
      const author = { ...this.state.authors[`${type}`] };
      author.client = _.get(author,"client",loggedInClient);
      author.assignedDate = new Date().toISOString();
      authors.push(author);
    });
    let testDetails = _.get(
      newRequestData,
      "requestInfo.details.testDetails",
      {}
    );
    if (!testDetails) {
      testDetails = {};
    }
    testDetails.authors = authors;
    newRequestData.requestInfo.details.testDetails = testDetails;
    const testOwner = newRequestData.requestInfo.owners.find(
      ({ type }) => {
        return type === "test-compiler";
      }
    );
    if (testOwner) {
        testOwner.roles={
          creator,evaluator,publisher,languageEvaluator,moderator
        }
    } 
    this.setState({ newRequestData }, () => {
      transferToParent({...newRequestData});
      this.props.onClose();
    });
  };
  dialogReset = () => {
    this.setState({   evaluator: {endDate: "" },
    creator: {endDate: "" },
    languageEvaluator: {endDate: "" },
    moderator: {endDate: "" },
    publisher: {endDate: "" },
    authors: {},
    error:{
      creator: {showError:false,errorText:''},
      evaluator: {showError:false,errorText:''},
      languageEvaluator:  {showError:false,errorText:''},
      moderator:  {showError:false,errorText:''},
      publisher:  {showError:false,errorText:''},
    }
  });
  };
  render() {
    const {
      classes,
      contentsubType,
      requestContentType,
      requestData,
      onClose,
    } = this.props;
    const{creator,evaluator,languageEvaluator,moderator,publisher,usersList,authors,error}=this.state;
    const { requestInfo } = requestData;
  
    const requestEndDate = requestInfo.endDate
      ? new Date(requestInfo.endDate)
      : requestInfo.endDate;

    const requestStartDate = requestInfo.startDate
      ? new Date(requestInfo.startDate)
      : requestInfo.startDate;

    const minimumDates = getMinimumDateForRoles({ creator, evaluator, languageEvaluator, moderator, publisher }, new Date(requestStartDate));

    return (
      <MyPATDialog
        dialogOpen={true}
        dialogHasActions={true}
        className={{root: classes.mb25}}
        isPerfectScrollbar={false}
        dialogHeading={
          <>
            <Grid container justify="flex-start">
              <Typography className={classes.AuthorHeading}>
                Add Test Owners &amp; specify their deadlines
              </Typography>
              <Typography className={classes.AuthorSubHeading}>
                Select authors responsible for creating, evaluating, moderating,
                publishing test, along with deadlines
              </Typography>
            </Grid>
          </>
        }
        isAlignCenter={false}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: true,
          maxWidth: 'md',
          scroll: 'body'
        }}
        isOverflowVisible={true}
        onDialogClose={this.props.onClose}
        hasDialogAction={false}
        isCustomWrapper = {true}
        customHtmlWrapper ={
          <>
          <Grid container justify="flex-start" spacing={24} className={[classes.dialogHeight,
        classes.transitionCSS, classes.testOwnerdialog].join(' ')}>
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography className={classes.popupLabel}>
                Add Test Creator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Creator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Creator"
                  imageURL=""
                  dialogPara="Author under creator category has the responsibility to create tests on CMS and get it verified and approved by Evaluator/ Lang. Evaluator/ Moderator/ Publisher. It is mandatory to define a creator for tests"
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATMultiSearch
                options={usersList}
                labelKey="name"
                valueKey="id"
                onChange={this.handleSuggestionSelect.bind(this)}
                values={authors.creator}
                isSearchAble={true}
                isCustomFilter={true}
                filtredFunction={this.getUsersByRole.bind(this)}
                name="creator"
                placeholderText="Search Test Creator and add"
                error={error.creator.showError}
                errorText={error.creator.errorText}
              />
            </Grid>
            <Grid item xs={6} className={classes.customCalendar2}>
            <Typography className={classes.popupLabel}>Add Deadline</Typography>
           
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) => this.handleDeadlineChange("creator", date)}
              date={creator.endDate}
              disabled={!requestEndDate || !requestStartDate}
              minDate={minimumDates.creator.endDate}
              maxDate={requestEndDate}
              errorText="Creation date cannot be less than request start date or more that request end date"
              // label="Content Creation"
            />
            
          </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>
                Add Test Evaluator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Evaluator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Evaluator"
                  imageURL=""
                  dialogPara="Author under Evaluator category can evaluate the tests and provide feedback to the users under preceding category. He/She can also edit the tests if needed. This category is optional.."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATMultiSearch
                options={usersList}
                labelKey="name"
                valueKey="id"
                onChange={this.handleSuggestionSelect.bind(this)}
                values={authors.evaluator}
                isSearchAble={true}
                isCustomFilter={true}
                filtredFunction={this.getUsersByRole.bind(this)}
                name="evaluator"
                placeholderText="Search Test Evaluator and add"
                error={error.evaluator.showError}
                errorText={error.evaluator.errorText}
              />
            </Grid>
            <Grid item xs={6} className={classes.customCalendar2}>
            <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>Add Deadline</Typography>
           
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) => this.handleDeadlineChange("evaluator", date)}
              date={evaluator.endDate}
              disabled={!requestEndDate || !requestStartDate}
              minDate={minimumDates.evaluator.endDate}
              maxDate={requestEndDate}
              errorText="Evaluation date cannot be less than creator's end date or more that request end date"
              initiallyTouched={false}
              // label="Content Creation"
            />
          </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>
                Add Test Lang. Evaluator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Lang. Evaluator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Lang. Evaluator"
                  imageURL=""
                  dialogPara="Author under Language Evaluate category can evaluate language of the tests and provide feedback to the users under preceding category. He/She can also edit the tests if needed. This category is optional."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATMultiSearch
                options={usersList}
                labelKey="name"
                valueKey="id"
                onChange={this.handleSuggestionSelect.bind(this)}
                values={authors.languageEvaluator}
                isSearchAble={true}
                isCustomFilter={true}
                filtredFunction={this.getUsersByRole.bind(this)}
                name="languageEvaluator"
                placeholderText="Search Test Lang. Evaluator and add"
                error={error.languageEvaluator.showError}
                errorText={error.languageEvaluator.errorText}
              />
            </Grid>
            <Grid item xs={6} className={classes.customCalendar2}>
            <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>Add Deadline</Typography>
           
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) =>
                this.handleDeadlineChange("languageEvaluator", date)
              }
              date={languageEvaluator.endDate}
              disabled={!requestEndDate || !requestStartDate}
              minDate={minimumDates.languageEvaluator.endDate}
              maxDate={requestEndDate}
              errorText="Language Evaluation date cannot be less than evaluator's end date or more that request end date"
              initiallyTouched={false}
              // label="Content Creation"
            />
          </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>
                Add Test Moderator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Moderator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Moderator "
                  imageURL=""
                  dialogPara="Author under Moderator category can moderate the tests and provide feedback to the users under preceding category. He/She can also edit the tests if needed. This category is optional."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATMultiSearch
                options={usersList}
                labelKey="name"
                valueKey="id"
                onChange={this.handleSuggestionSelect.bind(this)}
                values={authors.moderator}
                isSearchAble={true}
                isCustomFilter={true}
                filtredFunction={this.getUsersByRole.bind(this)}
                name="moderator"
                placeholderText="Search Test Moderator and add"
                error={error.moderator.showError}
                errorText={error.moderator.errorText}
              />
            </Grid>
            <Grid item xs={6} className={classes.customCalendar2}>
            <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>Add Deadline</Typography>
           
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) => this.handleDeadlineChange("moderator", date)}
              date={moderator.endDate}
              disabled={!requestEndDate || !requestStartDate}
              minDate={minimumDates.moderator.endDate}
              maxDate={requestEndDate}
              errorText="Moderation date cannot be less than lang. evaluator's end date or more that request end date"
              initiallyTouched={false}
              // label="Content Creation"
            />
          </Grid>
          </Grid>
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>
                Add Test Publisher
                <CustomInfoIcon
                  infoDialogContentType="Add Test Publisher"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Publisher"
                  imageURL=""
                  dialogPara="Author under Publisher category can approve and publish the tests or provide feedback to the users under preceding category. He/She can also edit the tests if needed. It is mandatory to define a publisher for the tests"
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <Grid className="searchTransition">
              <MyPATMultiSearch
                options={usersList}
                labelKey="name"
                valueKey="id"
                onChange={this.handleSuggestionSelect.bind(this)}
                values={authors.publisher}
                isSearchAble={true}
                isCustomFilter={true}
                filtredFunction={this.getUsersByRole.bind(this)}
                name="publisher"
                placeholderText="Search Test Publisher and add"
                error={error.publisher.showError}
                errorText={error.publisher.errorText}
              />
              </Grid>
            </Grid>
            <Grid item xs={6} className={classes.customCalendar2}>
            <Typography className={[classes.popupLabel, classes.pdTop6].join(' ')}>Add Deadline</Typography>
            <Grid className="calenderTransition">
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) => this.handleDeadlineChange("publisher", date)}
              date={publisher.endDate}
              disabled={!requestEndDate || !requestStartDate}
              minDate={minimumDates.publisher.endDate}
              maxDate={requestEndDate}
              errorText="Publishing date cannot be less than moderator's end date or more that request end date"
              // label="Content Creation"
            />
            </Grid>
          </Grid>
          </Grid>
        </Grid>


            <Grid              
              container
              justify="flex-end"
              spacing={8}
              alignItems="center"    
              className={classes.testOwnerdialogFooter}          
            >
              <Grid item>
                <Button color="primary" onClick={this.dialogReset.bind(this)}>Reset</Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onDone.bind(this)}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
            
          </>
        }
      >
        
      </MyPATDialog>
    );
  }
}
const defaultEndDates = {
  creator: { endDate: "" },
  evaluator: { endDate: "" },
  languageEvaluator: { endDate: "" },
  moderator: { endDate: "" },
  publisher: { endDate: "" },
};
const mapStateToProps = (state: any) => {
  return {
    userRoleMap: state.contentRequestReducer.contentRequestCreateReducer.userRoleMap,
  };
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setUserByRole
}, dispatch);
 // @ts-ignore
export default connect(mapStateToProps,mapDispatchToProps)(withStyles(ContentOwnersStyle)(SelectTestOwners));
